import { defaultsDeep } from 'lodash';
import { ACCOUNT_TYPES, CURRENCIES, PAYMENT_CYCLES, TRANSACTION_TYPES } from '../../../resources/enums';
import { Customer } from '../customer/Customer';
import { ICustomer } from '../customer/ICustomer';
import { ITransaction, Transaction } from '../transaction/Transaction';
import { IUser, User } from '../User';
import { SusuCycle } from '../../../resources/types';

export class Account {
  id: string;
  type: ACCOUNT_TYPES;
  accountNumber: string;
  status: string;
  transactions: Transaction[];
  branchCode: string;
  createdAt: Date;
  updatedAt: Date;
  customer_id: string;
  customer: Customer;
  balance: number;
  currency: CURRENCIES;
  name: string;
  rate: number;
  payment_cycle: PAYMENT_CYCLES
  purpose: string;
  accountManager: User;
  availableBalnce: number;
  susuCycles: SusuCycle[];
  cyclesAvailableForWithdrawal: SusuCycle[];
  computedBalance: number;
  totalDeposits: number;
  recentTransactions: Transaction[];

  constructor(IModel: IAccount) {
    this.id = IModel.id;
    this.type = IModel.type as ACCOUNT_TYPES;
    this.transactions = IModel.transactions?.map((transaction: ITransaction) => new Transaction(transaction)) ?? [];
    this.accountNumber = IModel.account_number;
    this.status = IModel.status;
    this.branchCode = IModel.branch_code;
    this.customer_id = IModel.customer_id;
    this.customer = IModel.customer && new Customer(IModel.customer);
    this.createdAt = new Date(IModel.created_at);
    this.updatedAt = new Date(IModel.updated_at);
    this.balance = IModel.balance;
    this.currency = IModel.currency as CURRENCIES ?? CURRENCIES.GHS;
    this.name = IModel.name ?? "";
    this.rate = IModel.rate ?? 0;
    this.payment_cycle = IModel.payment_cycle as PAYMENT_CYCLES
    this.purpose = IModel.purpose;
    this.accountManager = IModel.account_manager && new User(IModel.account_manager);
    this.availableBalnce = IModel.available_balance;
    this.susuCycles = IModel.susu_cycles;
    this.cyclesAvailableForWithdrawal = IModel.cycles_available_for_withdrawal;
    this.computedBalance = IModel.computed_balance;
    this.totalDeposits = IModel.total_deposits;
    this.recentTransactions = IModel.recent_transactions?.map((transaction: ITransaction) => new Transaction(transaction)) ?? [];
  }

  isSUSU(): boolean {
    return this.type === ACCOUNT_TYPES.SUSU;
  }
}

export interface IAccount {
  id: string;
  type: string;
  account_number: string;
  status: string;
  created_at: string;
  updated_at: string;
  transactions: ITransaction[];
  branch_code: string;
  customer_id: string;
  customer: ICustomer;
  balance: number;
  currency?: string;
  name: string;
  rate: number;
  payment_cycle: string;
  purpose: string;
  account_manager: IUser;
  available_balance: number;
  susu_cycles: SusuCycle[];
  cycles_available_for_withdrawal: SusuCycle[];
  computed_balance: number;
  total_deposits: number;
  recent_transactions: ITransaction[];
}
